<script lang='ts'>
    import { onMount } from 'svelte'
    import { _ } from 'svelte-i18n'
    import { addWeeks, format } from 'date-fns';
    import { type am5AxisRendererY, type am5DataItemWithIDateAxisDataItem, type am5DateAxisWithAxisRenderer, getTypedAm5 } from '@/Util/XertAm5';
    import { xssColors } from '@/Common/constants';

    const { am5, am5xy, am5themes_Animated, am5themes_Responsive } = getTypedAm5()
    am5.addLicense('AM5C87942260');
  
    let legendToggled = []
    let firstLoad = true;

    function getTimezoneOffsetStr() {
        var currentDate = new Date();
        var offsetMinutes = currentDate.getTimezoneOffset();
        var offsetHours = Math.abs(offsetMinutes) / 60;

        var offsetSign = offsetMinutes > 0 ? '-' : '+';
        var offsetFormatted = offsetSign + padZero(offsetHours) + ':00';

        return 'GMT' + offsetFormatted;
    }

    function padZero(num) { return (num < 10 ? '0' : '') + num; }

    function getStoredState() {
        const storedState = localStorage.getItem('legendToggledStorage');
        return storedState ? JSON.parse(storedState) : []; // Default state if not found
    }
    function updateState(newState) { localStorage.setItem('legendToggledStorage', JSON.stringify(newState)); }

    function createLegend(){
        const toggledSeries = [...chart.series].filter(s => s.dataItems.length > 0)
        legend.data.setAll(toggledSeries)
    }

    export const showAllLegend = ()=>{
        [...chart.series].forEach(series =>{
            series.set("visible", true);
            series.show();
        });
    }

    function setLegend(){
        Object.entries(everySeries).forEach(([name, series]) => {
            if(series && series?.data) series.data.clear()
        });

        legendToggled = (firstLoad)? getStoredState():[...chart.series].filter(s => {return !s.get("visible");});
        firstLoad = false;
        // console.log("toggling");
        [...chart.series].forEach(series =>{
            if(legendToggled.includes(series._settings.valueYField)){
                series.set("visible", false);
                series.hide()
            }
            // else{
            //     series.show();
            // }
        });
        updateState( [...chart.series].filter(s => {return !s.get("visible");}).map(s =>(s._settings.valueYField)) );
    }

    function clearData() {
        Object.entries(everySeries).forEach(([name, series]) => {
            if(series) everySeries[name].data.clear()
        });
    }
  
    export let stats
    export let range: [Date, Date]
    export let displayedStats: any[]
    export let cal_settings;
    export let chart_id = 'cal_stats_chart';
  
    let dateAxis: am5DateAxisWithAxisRenderer

    const colours = {
        // Colours to match MPA chart
        low: am5.color(xssColors.xlss),
        high: am5.color(xssColors.xhss),
        peak: am5.color(xssColors.xpss),
        
        // Freshness colours.
        very_fresh: am5.color('#00FF00'),
        fresh: am5.color('#0000FF'),
        tired: am5.color('#FFC200'),
        very_tired: am5.color('#FF0000'),
        detraining: am5.color('#B45F04'),

        black: am5.color('#000000'),
        gray: am5.color('#808080'),
        white: am5.color('#ffffff'),
    }
    // light colors for column chart without opacity.
    const lighter_colours = {
        // Colours to match MPA chart
        low: am5.Color.lighten(colours.low, 0.4),
        high: am5.Color.lighten(colours.high, 0.4),
        peak: am5.Color.lighten(colours.peak, 0.4),
       
    }

    function getDateRange(startDate, endDate) {
        const dateRange = [];
        let currentDate = new Date(startDate);

        const jumpSize = 1;
        while (currentDate <= endDate) {
            dateRange.push(new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + jumpSize);
        }

        return dateRange;
    }

    function flattenWeek(data){
        const lengthOfLine = 1;
       return data.flatMap(d =>(
            [...getDateRange(new Date(d.t), new Date(d.t).setDate(new Date(d.t).getDate()+lengthOfLine))].map(day=>(
                {
                ...d,
                t:day.getTime(),
                }
            ))
      ));
    }
    // function cartesianProduct(arr1, arr2) {
    //     return arr1.flatMap((x) => arr2.map((y) => [x, y]));
    // }

    // // Usage:
    // const startDate = new Date('2023-01-01');
    // const endDate = new Date('2023-01-10');

    // const range = getDateRange(startDate, endDate);
    // console.log(range);

    if (!displayedStats) console.error('displayedStats not set')


    // ToolTip ////
    const tooltipBackground = {
        stroke: colours.black,
        strokeWidth: 1.5,
        strokeOpacity: 1,

        fill: colours.white,
        fillOpacity: 0.85,
    }
    const tooltipSettings = {
        getFillFromSprite: false,
        getStrokeFromSprite: false,
        autoTextColor: false,
    }

    const weeklyFocusTooltip = () => ({
        tooltip: am5.Tooltip.new(root, {
            ...tooltipSettings,
            labelText: '{name}: [bold]{tooltip}[/]',
        // labelText: '{name}: [bold]{valueY.formatNumber("#.#")}[/]',
        }),
    });

    const ptlTooltip = () => ({
        tooltip: am5.Tooltip.new(root, {
            ...tooltipSettings,
            labelText: '{name}: [bold]{valueY.formatNumber("#.##")}[/]',
        }),
    });


    const tooltip = () => ({
        tooltip: am5.Tooltip.new(root, {
            ...tooltipSettings,
            labelText: '{name}: [bold]{valueY.formatNumber("#.#")}[/]',
        }),
    });
    ////////////

    const Styles = {
        dashed:{
            strokeWidth: 3.0,
            strokeOpacity: 0.6,
            strokeDasharray: [10, 5, 2, 5],
        },
        solid:{
            strokeWidth: 3.0,
            strokeOpacity: 0.6,
        },
        solid2:{
            strokeWidth: 4.0,
            opacity: 0.4,
        },
        solid3:{
            strokeWidth: 4.0,
            opacity: 0.8,
        },
        solid4:{
            strokeWidth: 4.0,
            opacity: 0.7,
        },
        solid5:{
            strokeWidth: 2.5,
            opacity: 1,
        },
        solid6:{
            strokeWidth: 2.0,
            opacity: 0.9,
        },
        solid7:{
            strokeWidth: 2.0,
            opacity: 0.8,
        }
    }

    var everySeriesStyle = {
        xss :           Styles.solid,
        xlss :          Styles.dashed,
        xhss :          Styles.dashed,
        xpss:           Styles.dashed,
        weeklyXssPerDay:Styles.solid,
        tl:             Styles.solid,
        ltl :           Styles.solid,
        htl :           Styles.solid,
        ptl:            Styles.solid,
        rl :            Styles.solid,
        weeklyHours :   Styles.solid2,
        weeklyFocus :   Styles.solid3,
        ftp :           Styles.solid3,
        pp :            Styles.solid3,
        ltp :           Styles.solid4,
        focusPower :    Styles.solid4,
        hie :           Styles.solid3,
        weeklyDistance :Styles.solid5,
        form :          Styles.solid5,  
        weeklyRampRate :Styles.solid5,
        specificity :   Styles.solid6,
        intensityRatio : Styles.solid7,
    }

    var everySeries = {
        tl: null,
        rl: null,
        ltl: null,
        htl: null,
        ptl: null,
        form: null,
        xss: null,
        xlss: null,
        xhss: null,
        xpss: null,
        specificity: null,
        weeklyHours: null,
        weeklyDistance: null,
        weeklyXssPerDay: null,
        weeklyRampRate: null,
        weeklyFocus: null,
        ftp: null,
        hie: null,
        pp: null,
        ltp: null,
        focusPower: null,
        intensityRatio: null,
    }

    const keyMap = {
        ltl: 'ltl',
        htl:'htl',
        ptl: 'ptl',
        ftp: 'ftp',
        hie:'hie',
        pp:'pp',
        distance:'total_distance',
        xss:'xss_week',
        tl:'tl',
        rl:'rl',
        ltp:'ltp',
        xlss:'xlss',
        xhss:'xhss',
        xpss:'xpss',
        athlete_fp:'athlete_fp',
        form:'form',
        sp:'xss_spr',
        xssPerDay:'xss',
        focus:'xss_focus',
        weekly_hours:'total_time',
        rampRate:'ramp_rate',
        ratio:'polarity_ratio',
    }


    // Fill in chart background to show start/end of week
    const firstWordOfToFloat = (str: string) => {
        // Take just the first word and convert to number
        // str in format: '42.9 <span style="color: #FF0000">-75</span>'
        return parseFloat(str); //.replace(/ .*/,'')
    }

    let todayRange: am5DataItemWithIDateAxisDataItem
    let highlightRange: am5DataItemWithIDateAxisDataItem
    let weekRanges = []
    function drawBackground(day, end){
        while(day < end) {
            const range = dateAxis.createAxisRange(dateAxis.makeDataItem({
                value: day.getTime(),
                endValue:  addWeeks(day, 1).getTime(),
            }))
    
            range.get('axisFill').setAll({
                fill: colours.black,
                fillOpacity: 0.05,
                visible: true
            });
            weekRanges.push(range)
            day = addWeeks(day, 2)
        }
    }
    function clearBackground(){
        weekRanges.forEach(range => { 
            range.get('axisFill').setAll({
                fill: colours.white,
                fillOpacity: 0.05,
                visible: true
                })
        });
        weekRanges=[];
    }
    

    $: if (stats && displayedStats && mounted) {
        //capture toggled state and clear chart background
        let toggledStats = Object.fromEntries(displayedStats.map(stat => [stat.value, stat.preselected]));
        clearBackground();
        
        //build chart data series from stats
        let _data = []
        // Split each day into two data points on chart, before and after the activity.
        for(const weekKey of Object.keys(stats)) {
            const week = stats[weekKey]
            const t = (new Date(weekKey)).getTime() + ((new Date()).getTimezoneOffset())*60*1000;
            if (t > range[0].getTime() && t < range[1].getTime()) 
                _data.push({t, ...week})
        }

        _data = _data.sort((a, b)=> a.t - b.t);
    
        _data = _data.map(d => {
            const timeString = d.xss_focus.match(/(\d{1,2}):(\d{1,2})/)?.at(0)
            const rampRateStr: string | null = d.ramp_rate.match(/>.*</)?.at(0) ?? null
            const ratioStr: string | null = d.polarity_ratio?.match(/\d{1,2}/)?.at(0) ?? null

            return{ 
                ...d,
                ltl:            firstWordOfToFloat(d.ltl),
                htl:            firstWordOfToFloat(d.htl),
                ptl:            firstWordOfToFloat(d.ptl),
                ftp:            firstWordOfToFloat(d.ftp),
                hie:            firstWordOfToFloat(d.hie),
                pp:             firstWordOfToFloat(d.pp),
                distance:       firstWordOfToFloat(d.total_distance),
                xss:            d.xlss + d.xhss + d.xpss,
                xssPerDay:      d.xss_week / 7,
                weekly_hours:   d.duration / 3600,
                focus:          (timeString?(parseInt(timeString.split(':')[0]) * 60) + parseInt(timeString.split(':')[1]):0 ), 
                tooltip:        timeString,
                rampRate:       (rampRateStr)?parseInt(rampRateStr.slice(1, rampRateStr.length-1)):0,
                ratio:          (ratioStr)?parseInt(ratioStr) / 100:0,
            }
        });

        //reset legend and chart series data
        setLegend();
        clearData();
        Object.entries(everySeries).forEach(([key, series])=>{
            if(toggledStats[keyMap[series._settings.valueYField]]){
                everySeries[key].data.setAll( _data)
            }
        })
        //redraw background
        const tzStr = getTimezoneOffsetStr();
        let day = new Date(_data[0].datestart + tzStr);
        let end = new Date(_data[_data.length-1].datestart + tzStr);

        drawBackground(day, end);
        createLegend();
    }
  
    let mounted = false
    let chart = null
    let legend = null
    let root;
    onMount(()=>{    
        // console.log("on Mount");
        legendToggled = getStoredState();
        root = am5.Root.new(chart_id)
  
        // Use local timezone for date axis
        root.utc = false
        const responsive = am5themes_Responsive.new(root);

        responsive.addRule({
        name: "AxisRendererY",
        relevant: function(width, height) {
            return width < 1000;
        },
        settings: {
            inside: true
        }
        });

        // let legendRoot = am5.Root.new('activity_legend')
        root.setThemes([am5themes_Animated.new(root), responsive])
        // legendRoot.setThemes([am5xy.DefaultTheme.new(legendRoot)])

        chart = root.container.children.push( am5xy.XYChart.new(root, {
            paddingTop: -8,
            paddingLeft: 0,
            // paddingBottom: 0,
            paddingRight: -70,
            layout: root.verticalLayout,
            maxTooltipDistance: -1,
            //pinchZoomX: true,
            //panX: true,
            //wheelY: "zoomX",
            // arrangeTooltips: false,
        }));
  
        let axisConfig = {
            strokeOpacity: 1,
            strokeWidth: 2,
            minGridDistance: 40,
            visible: false,
            forceHidden: true,
        }
        let axisGridConfig = {
            disabled: true,
            visible: false,
        }

        const locationX = 0.0;
        const axisSettings = ()=> ({
            valueXField: 't',
            xAxis: dateAxis,
            locationX: locationX,
        });

        const lineSeriesSettings = (tension:number = 0.15) => ({
            ...axisSettings(),
            ...tooltip(),
            tension: tension, // smoothed line series tension
        })
        
        function newSeries(args){
            return chart.series.push(am5xy.SmoothedXLineSeries.new(root, {
                ...args,
            }));
        }

        function newYAxis(args, dataItem = null){
            let axis = chart.yAxes.push(am5xy.ValueAxis.new(root, args));
            if(dataItem)
                axis.createAxisRange(axis.makeDataItem(dataItem))
            return axis;
        }

        function defaultRenderer(root): am5AxisRendererY{
                let _defaultRenderer = am5xy.AxisRendererY.new(root, axisConfig);
                _defaultRenderer.labels.template.set('visible', false);
                _defaultRenderer.grid.template.setAll(axisGridConfig);
            
            return _defaultRenderer;
        }

        function oppositeRenderer(root) : am5AxisRendererY{
                let _oppositeRenderer = am5xy.AxisRendererY.new(root, {...axisConfig, opposite:true,});
                _oppositeRenderer.labels.template.set('visible', false);
                _oppositeRenderer.grid.template.setAll(axisGridConfig);
            
            return _oppositeRenderer;

        }

        const axes={
            axis1: (root) => newYAxis({
                maxPrecision: 1,
                min: 0,
                extraMax: 0.05,
                renderer: defaultRenderer(root),
            }),
            axis2:(root) =>{
                let axis = newYAxis({
                    maxPrecision: 0.1,
                    min: 0,
                    extraMax: 0.1,
                    renderer: oppositeRenderer(root),
                }, );
                axis.events.on('boundschanged', (event)=>{
                    let h = axis.height();
                    if (h > 0) {
                    todayRange.get('label').set('dy', 10 - h)
                    }
                });
                return axis;
            },
            axis3:(root) =>newYAxis({
                maxPrecision:0.01,
                min: 0,
                extraMax: 0.1,
                renderer: oppositeRenderer(root),
            }),
            axis4:(root) =>newYAxis({
                min: 0,
                extraMax: 0.1,
                renderer: oppositeRenderer(root),
            }),

            axis5:(root) =>newYAxis({
                extraMax: 0.1,
                renderer: oppositeRenderer(root),
            }),
            axis6:(root) =>newYAxis({
                extraMax: 0.1,
                renderer: defaultRenderer(root),
            }),
            axis7:(root) =>newYAxis({
                renderer: oppositeRenderer(root),
                }, {
                value: 0,
                endValue: 1,
            }),
        }

        var xssAxis = axes.axis1(root);
        var smallXssAxis = axes.axis1(root);
        var tlAxis = axes.axis2(root);
        var smallTlAxis = axes.axis3(root)
        var hoursAxis = axes.axis4(root);
        var secondsAxis = axes.axis4(root);
        var powerAxis = axes.axis5(root);
        var energyAxis = axes.axis6(root);
        var distanceAxis = axes.axis5(root);
        var formAxis = axes.axis5(root);
        var rampRateAxis = axes.axis5(root)
        var ratioAxis = axes.axis7(root);

        let dateAxisRenderer = am5xy.AxisRendererX.new(root, {
            strokeOpacity: 1,
            strokeWidth: 2,
        })
        dateAxis = chart.xAxes.push(am5xy.DateAxis.new(root, {
            extraMax: 0.02,
            baseInterval: {timeUnit: 'raw', count:1}, //, count: 24*3600*1000
            // tooltipIntervalOffset should match locationX: 0 of series otherwise it shows value 12 hours in future.
            snapTooltip: false,
            tooltipIntervalOffset: locationX,
            renderer: dateAxisRenderer,
            // tooltipDateFormat: 'ss',
            tooltipDateFormat: 'EEE, dd MMM yyyy',
            tooltip: am5.Tooltip.new(root, {
                themeTags: ['axis'],
            })
        }))
        //used to account for the daylight savings time
        class MyDateFormatter extends am5.DateFormatter {
            timezoneOffset = (new Date()).getTimezoneOffset(); // the user's current time zone
            format(source, formatOptions) {
                let value = source.getTime();
                value += (source.getTimezoneOffset() - this.timezoneOffset) *60*1000; // offset to account for spring forward or fall back, all dates are converted to the current time zone offset, ensure at date tooltips are the shown as the same day of the week
                return format(new Date(value), formatOptions)
            }
        }
        root.dateFormatter = MyDateFormatter.new(root, {});

        //   dateAxis.adapters.add('min', (min)=>{
        //     // Offset min by -6 hours to account for locationX: 0 used on all series. Otherwise columns get cut off on the first day
        //     // since default behaviour is to have column in between adjacent grid lines, while this chart has the columns centred on the grid.
        //     // Since column is centered, only half of the total space is needed, so -6 hours compared to the 12 hour default offset.
        //     return min - 6*3600*1000
        //   })
        dateAxisRenderer.grid.template.setAll(axisGridConfig)
        dateAxisRenderer.labels.template.setAll({
            minPosition: 0.0,//0.05,
            location: 0.0,
            multiLocation: 0.0,
        })
        //...lineSeriesSettings(), includes the xAxis: dateAxis, which must be create before a call to ...lineSeriesSettings
        const everySeriesArgs = {
            xss : {
                ...lineSeriesSettings(),
                valueYField: 'xss',
                name: 'XSS',
                yAxis: xssAxis,
                stroke: colours.gray,
            },
            xlss : {
                ...lineSeriesSettings(),
                valueYField: 'xlss',
                name: 'XLSS',
                yAxis: xssAxis,
                stroke: colours.low, 
            },
            xhss : {
                ...lineSeriesSettings(),
                valueYField: 'xhss',
                name: 'XHSS',
                yAxis: smallXssAxis,
                stroke: colours.high, 
            },
            xpss : {
                ...lineSeriesSettings(),
                valueYField: 'xpss',
                name: 'XPSS',
                yAxis: smallXssAxis,
                stroke: colours.peak, 
            },
            weeklyXssPerDay : {
                ...lineSeriesSettings(),
                valueYField: 'xssPerDay',
                name: 'XSS/Day',
                yAxis: xssAxis,
                stroke: am5.color('#00ff00'),
            },
            tl : {
                ...lineSeriesSettings(),
                name: 'Training Load',
                valueYField: 'tl',
                yAxis: tlAxis,
                stroke: colours.black,
            },
            ltl : {
                ...lineSeriesSettings(),
                name: 'Low Training Load',
                valueYField: 'ltl',
                yAxis: tlAxis,
                stroke: colours.low,
            },
            htl : {
                ...lineSeriesSettings(),
                name: 'High Training Load',
                valueYField: 'htl',
                yAxis: smallTlAxis,
                stroke: colours.high,
            },
            ptl : {
                ...axisSettings(),
                ...ptlTooltip(),
                name: 'Peak Training Load',
                valueYField: 'ptl',
                yAxis: smallTlAxis,
                stroke: colours.peak,
            },
            rl : {
                ...lineSeriesSettings(),
                name: 'Recovery Load',
                valueYField: 'rl',
                yAxis: tlAxis,
                stroke: colours.gray,
            },
            weeklyHours : {
                ...lineSeriesSettings(),
                valueYField: 'weekly_hours',
                name: 'Weekly Hours',
                stroke: am5.color('#FF5B5B'),
                //fill: colours.white, // Set fill to white so that label text is auto-set to black.
                yAxis: hoursAxis,
            },
            weeklyFocus : {
                ...axisSettings(),
                ...weeklyFocusTooltip(),
                valueYField: 'focus',
                name: 'Focus Duration',
                stroke: am5.color('#009600'),//'#59ff21'),
                //fill: colours.white, // Set fill to white so that label text is auto-set to black.
                yAxis: secondsAxis,
            },
            ftp : {
                ...lineSeriesSettings(),
                valueYField: 'ftp',
                name: 'Threshold Power',
                stroke: colours.low,
                //fill: colours.white, // Set fill to white so that label text is auto-set to black.
                yAxis: powerAxis,
            },
            pp : {
                ...lineSeriesSettings(),
                valueYField: 'pp',
                name: 'Peak Power',
                stroke: colours.peak,
                //fill: colours.white, // Set fill to white so that label text is auto-set to black.
                yAxis: powerAxis,
            },
            ltp : {
                ...lineSeriesSettings(),
                valueYField: 'ltp',
                name: 'Lower Threshold Power',
                stroke: am5.color('#ffcd45'),
                //fill: colours.white, // Set fill to white so that label text is auto-set to black.
                yAxis: powerAxis,
            },
            focusPower : {
                ...lineSeriesSettings(),
                valueYField: 'athlete_fp',
                name: 'Focus Power',
                stroke: am5.color('#5921ff'),
                //fill: colours.white, // Set fill to white so that label text is auto-set to black.
                yAxis: powerAxis,
            },
            hie : {
                ...lineSeriesSettings(),
                valueYField: 'hie',
                name: 'High Intensity Energy',
                stroke: colours.high,
                //fill: colours.white, // Set fill to white so that label text is auto-set to black.
                yAxis: energyAxis,
            },
            weeklyDistance : {
                ...lineSeriesSettings(),
                valueYField: 'distance',
                name: 'Weekly Distance',
                stroke: colours.gray,
                //fill: colours.white, // Set fill to white so that label text is auto-set to black.
                yAxis: distanceAxis,
            },
            form : {
                ...lineSeriesSettings(),
                valueYField: 'form',
                name: 'Form',
                stroke: am5.color('#21edff'),
                //fill: colours.white, // Set fill to white so that label text is auto-set to black.
                yAxis: formAxis,
            },
            weeklyRampRate : {
                ...lineSeriesSettings(),
                valueYField: 'rampRate',
                name: 'Ramp Rate',
                stroke: am5.color('#ff21e9'),
                //fill: colours.white, // Set fill to white so that label text is auto-set to black.
                yAxis: rampRateAxis,
            },
            specificity : {
                ...lineSeriesSettings(),
                valueYField: 'sp',
                name: 'Specificity',
                stroke: am5.color('#ff216b'),
                //fill: colours.white, // Set fill to white so that label text is auto-set to black.
                yAxis: ratioAxis,
            },
            intensityRatio : {
                ...lineSeriesSettings(),
                valueYField: 'ratio',
                name: 'Intensity Ratio ',
                stroke: am5.color('#ff5121'),
                //fill: colours.white, // Set fill to white so that label text is auto-set to black.
                yAxis: ratioAxis,
            },
        }

        //create new series from args
        Object.entries(everySeries).forEach(([key, value])=>{
            if(everySeriesArgs[key])
                everySeries[key] = newSeries(everySeriesArgs[key]);
        });

        //set styles for all new series
        Object.entries(everySeries).forEach(([key,value])=>{
            if(value) value?.strokes.template.setAll(everySeriesStyle[key])
        })

        Object.entries(everySeries).forEach(([key,value])=>{
            if(value) everySeries[key].bullets.push(function () {
                    return am5.Bullet.new(root, {
                        //locationY: 0,
                        sprite: am5.Circle.new(root, {
                            radius: 4,
                            stroke: everySeries[key].get("stroke"),
                            strokeWidth: 2,
                            fill: everySeries[key].get("stroke")
                        })
                });
            });
        })

        chart.series.each(series => {
            series.getTooltip().get('background').setAll(tooltipBackground);
            series.getTooltip().label.setAll({
                fill: colours.black,
            });
        })
  
        const seriesWithTooltips = [...chart.series]

        chart.set('cursor', am5xy.XYCursor.new(root, {
            behavior: 'zoomX',
            snapToSeries: seriesWithTooltips,
            snapToSeriesBy: 'xy',
        }))
        chart.get('cursor').lineY.set('visible', false)

      
        root._tooltip.setAll({
            ...tooltipSettings
        })
        root._tooltip.get('background').setAll(tooltipBackground)

        todayRange = dateAxis.createAxisRange(dateAxis.makeDataItem({
            value: new Date().getTime(),
            endValue: new Date().getTime(),
        }));
  
        todayRange.get('grid').setAll({
            // stroke: colours.low,
            // strokeOpacity: 1
    
            stroke: colours.black,
            strokeWidth: 2,
            // strokeOpacity: 0.5,
            strokeOpacity: 1.0,
            strokeDasharray: [3, 3],
            visible: true,
            
            // Line at end of range.
            location: 1.0,
        });
  
        todayRange.get('label').setAll({
            // fill: am5.color(0xFF0000),
            text: 'Today',
            visible: true,
            location: 1.0,
    
            inside: true,
            rotation: -90,
            dx: -20,
            // dy: 10,
            centerX: am5.p100,
        });
  
        highlightRange = dateAxis.createAxisRange(dateAxis.makeDataItem({
            value: new Date().getTime(),
            endValue: new Date().getTime(),
        }));
  
        highlightRange.get('axisFill').setAll({
            fill: am5.color(0x00FF00),
            fillOpacity: 0.2,
            visible: true
        });
  
        tlAxis.events.on('boundschanged', (event)=>{
            let h = tlAxis.height();
            if (h > 0) {
                todayRange.get('label').set('dy', 10 - h)
            }
        });
  
  
        // Debounce switching between different types of tooltip based on what the cursor is hovering over.
        enum TooltipsToShow {
            FormBullet,
            OtherSeries
        }
        let debouncer = {
            tooltipToShow: TooltipsToShow.OtherSeries,
            debounceTimer: null,
            // showFormTooltip(){
            //   if (this.tooltipToShow != TooltipsToShow.FormBullet) {
            //     this.tooltipToShow = TooltipsToShow.FormBullet
            //     this.debounce()
            //   }
            // },
            showOtherTooltip(){
                if (this.tooltipToShow != TooltipsToShow.OtherSeries) {
                    this.tooltipToShow = TooltipsToShow.OtherSeries
                    this.debounce()
                }
            },
            debounce(){
            if (this.debounceTimer != null) clearTimeout(this.debounceTimer)
                this.debounceTimer = setTimeout(()=>{
                    this.debounceTimer = null;
                    switch(this.tooltipToShow) {
                    case TooltipsToShow.FormBullet:
                        for (let s of seriesWithTooltips) { s.getTooltip()?.set('forceHidden', true) }
                        break;
                    case TooltipsToShow.OtherSeries:
                        for (let s of seriesWithTooltips) { s.getTooltip()?.set('forceHidden', false) }
                        break;
                    }
                    // chart.arrangeTooltips()
                }, 200)
            }
        }
  
        //   let scrollbar = am5xy.XYChartScrollbar.new(root, {
        //     orientation: 'horizontal',
        //     // height: 50
        //     height: 30,
        //   })r
        //   chart.set('scrollbarX', scrollbar)
        let legendRoot = am5.Root.new("legend-div");
        legendToggled = getStoredState();
        // legend = chart.children.push(am5.Legend.new(root, {}));
        legend = legendRoot.container.children.push(am5.Legend.new(legendRoot, 
        
        {
            width: am5.percent(100),
            centerX: am5.percent(50),
            x: am5.percent(50),
            // layout: legendRoot.grid,
            // height: am5.percent(100),
            // layout: legendRoot.grid,
            centerY: am5.percent(50),
            y: am5.percent(50),
            // layout: root.vertical,
            // height: am5.percent(100),
            // width: am5.percent(100),
            // veritcalScrollbar: am5.Scrollbar.new(legendRoot, {
            //     orientation: "vertical"
            // }),
        }
        ));

        let horizontalScrollLegend = {
            centerY: am5.percent(50),
            y: am5.percent(50),
            layout: legendRoot.horizontalLayout
        }
        // legend.data.clear();

        let resizeLegend = () => {
            if(document.getElementById("legend-wrapper"))
                document.getElementById("legend-wrapper").style.height = legend.height() + "px";
            if(document.getElementById("legend-div"))
                document.getElementById("legend-div").style.height = legend.height()  + "px";
        }

        legend.events.on("boundschanged", resizeLegend);

        mounted = true
    })
    let showLegend = true;
    $:toggleLegendText = showLegend?"Hide Legend":"Show Legend";
</script>
  
    <div class="progression-chart" id={chart_id}></div>
    <div class="flex flex-col">
        <button on:click={()=>{showLegend=!showLegend}} class="calendar-button btn-default mb-1 float-right"><span class="btn-text">{toggleLegendText}</span><i style="flex-grow:0;" class={"ml-2 fas fa-chevron-"+(showLegend?"up":"down")} ></button>
        <div class="legend-wrapper" id="legend-wrapper" style={showLegend?"":"display:none;"}>
            <div class="legend-div" id={"legend-div"}></div>
        </div>
    </div>
  <style lang='scss'>
  :global {
    span.am5-stars {
      --star-color: black;
      --star-background: lightgray;
  
      &::before {
      // content: '◆ ◆ ◆ ◆ ◆';
      content: "\f005\f005\f005\f005\f005";
      // font-size: 2rem;
      background: linear-gradient(90deg, var(--star-color) var(--percent), var(--star-background) var(--percent));
  
      background-clip: text;
      -webkit-background-clip: text;
  
      -webkit-text-fill-color: transparent;
      }
    }
  }
  .progression-chart {
    // min-height:fit-content;
    // max-height: 550px;
    height: 420px;
    min-height: 420px;
    //max-width: 1000px;
    max-width:100%;
    // margin: 0 auto;
  }
  .legend-div{
    // height: 150px;
    height:10px;
    width:100%;
  }
  .legend-wrapper {
    width:100%;
    // overflow-x: scroll;
  }

  .calendar-button {
        // background-color: #FFF;
        display:flex;
        width:110px;
        // justify-self:right;
        border: 1px solid #3D3D3D;
        border-radius: 3px;
        font-size: 12px;
        color: #3D3D3D;
        margin-left: auto;
        padding: 4px 8px;
    }
    .btn-text{
        text-align: center;
        // min-width:20px;
        flex-grow:1;
    }



//   .amcharts-tooltip {
//       color: black; 
//     }

  </style>
  